import { render, staticRenderFns } from "./GuestBook.vue?vue&type=template&id=87d204cc&scoped=true"
import script from "./GuestBook.vue?vue&type=script&lang=js"
export * from "./GuestBook.vue?vue&type=script&lang=js"
import style0 from "./GuestBook.vue?vue&type=style&index=0&id=87d204cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d204cc",
  null
  
)

export default component.exports